// extracted by mini-css-extract-plugin
export default {"hidden":"downloadBudgetPDFModal_hidden__4-06d"};